import React, { useContext, useEffect, useState } from "react";
import "./Gifts_Category.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import Gift_Card from "../../common_components/gift_card/Gift_Card";
import Filter_By_Offcanvas from "../../common_components/filter_by_offcanvas/Filter_By_Offcanvas";
import Filter_div_btn from "../../common_components/filter_div_btn/Filter_div_btn";
import { Products } from "../../../utils/luxuryapis/Product/Product";
import { Context } from "../../../utils/context";
import { useSearchParams } from "react-router-dom";
import { encodeId } from "../../../utils/common";
import Product_add_to_cart_card from "../../common_components/product_add_to_cart_card/Product_add_to_cart_card";

const Gifts_Category = () => {
  const {
    IMG_URL,
    filters,
    updateFilter,
    resetFilters,
    toggleArrayFilter,
    applyFilters,
    cancelFilters,
    applied,
  } = useContext(Context);
  const [searchParams] = useSearchParams();

  const categoryId = searchParams.get("category_id");
  const occasionId = searchParams.get("occasion_id");
  const genderId = searchParams.get("gender_id");
  const Name = searchParams.get("name");
  const [showFilter, setShowFilter] = useState(false);

  const [productdata, setproductData] = useState();
  const getAllData = async () => {
    let res = await Products({
      category_id: categoryId || filters?.category_id,
      occasion_id: occasionId || JSON.stringify(filters?.occasion_ids),
      material_id: JSON.stringify(filters?.material_ids),
      brand_id: JSON.stringify(filters?.brand_ids),
      price_min: filters?.price_min,
      price_max: filters?.price_max,
      quantity: filters?.quantity,
      customisable: filters?.customisable,
      gender_id: genderId || "",
    });
    if (res?.success) {
      setproductData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllData();
  }, [categoryId, occasionId, filters, genderId]);

  return (
    <section className="Gifts_Category">
      <div className="top_heading_div">
        <div className="custom_container">
          <Common_Title pageTitle={Name || "All Products"} />
        </div>
      </div>
      <div className="all_products_div">
        <div className="custom_container">
          <Filter_div_btn
            btnText={"Filter By"}
            onClick={() => {
              setShowFilter(true);
            }}
          />

          <div className="div1">
            <div className="row justify-content-center">
              {productdata?.data?.length > 0 ? (
                productdata?.data?.map((product, index) => (
                  <div className="col-xl-3 col-md-4 col-sm-6 mb-3" key={index}>
                    {/* <Gift_Card
                      imgSrc={IMG_URL + item?.image1}
                      productName={item?.name}
                      path={`/luxury/product-details/${encodeId(item?.id)}`}
                    /> */}
                    <Product_add_to_cart_card
                      getDataWishlists={getAllData}
                      isWishlisted={productdata?.data}
                      product={product}
                      id={product.id}
                      image={IMG_URL + product.image1}
                      url={`/luxury/product-details/${encodeId(product?.id)}`}
                      title={product?.name}
                      mrp={
                        product.product_variants?.[0]?.product_quantities?.[0]
                          ?.mrp
                      }
                      selling_price={
                        product.product_variants?.[0]?.product_quantities?.[0]
                          ?.price
                      }
                      discount={
                        product.discount ||
                        (product?.product_variants?.[0]?.product_quantities?.[0]
                          ?.price > 0
                          ? Math.round(
                              ((product?.product_variants?.[0]
                                ?.product_quantities?.[0]?.mrp -
                                product?.product_variants?.[0]
                                  ?.product_quantities?.[0]?.price) /
                                product?.product_variants?.[0]
                                  ?.product_quantities?.[0]?.mrp) *
                                100,
                            )
                          : 0)
                      }
                    />
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <i className="fa fa-box-open fa-3x text-muted mb-3"></i>
                  <h5 className="text-muted">No Products Found</h5>
                  <p className="text-muted">
                    Sorry, we couldn't find any products.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Filter_By_Offcanvas
        show={showFilter}
        handleClose={() => setShowFilter(false)}
      />
    </section>
  );
};

export default Gifts_Category;
